import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import WhyUs from "@/components/sections/WhyUs";
import Booking from "@/components/sections/Booking";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-slate-50">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyUs />
        <Booking />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
